import { addDays, endOfDay, format, parseISO, startOfDay, subMonths } from 'date-fns';

export const getThreeMonthDateRange = (): { startDate: Date; endDate: Date } => {
  const endDate = startOfDay(addDays(new Date(), 1));
  const startDate = startOfDay(subMonths(endDate, 3));
  return { startDate, endDate };
};

export const validDate = (value?: string | null): Date | undefined =>
  value ? new Date(value) : undefined;

export const getTimestamp = (): string => {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${day}_${month}_${year}_${hours}_${minutes}_${seconds}`;
};

export const toStringDate = (date: Date): string => format(date, 'yyyy-MM-dd HH:mm:ss');

const parseDateValue = (date: string | Date): Date | null => {
  if (date instanceof Date) {
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const isoDate = parseISO(date);
  if (!Number.isNaN(isoDate.getTime())) {
    return isoDate;
  }

  const fallbackDate = new Date(date);
  return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
};

export const formatDateCustom = (date?: string | Date): string => {
  if (!date) return '';
  const d = parseDateValue(date);
  if (!d) return '';
  return format(d, 'dd/MM/yyyy');
};

export const formatDateTime = (date?: string | Date): string => {
  if (!date) return '';
  const d = parseDateValue(date);
  if (!d) return '';
  return format(d, 'dd/MM/yyyy HH:mm');
};

export const toLocalISODate = (date: Date): string => format(date, 'yyyy-MM-dd');

export const toStartOfDayUTC = (date: Date): string => format(startOfDay(date), 'yyyy-MM-dd HH:mm');

export const toEndOfDayUTC = (date: Date): string => format(endOfDay(date), 'yyyy-MM-dd HH:mm');

export const toLocalDateTime = (date: Date): string => format(date, 'yyyy-MM-dd HH:mm');

export const toLocalDateTimeWithSeconds = (date: Date): string =>
  format(date, 'yyyy-MM-dd HH:mm:ss');
